import Vue from "vue";
import Vuex from "vuex";
import AuthModule from "./auth_module";
import UserModule from "./user_module";
import MaidModule from "./maid_module";
import BookingModule from "./booking_module";
import CalendarModule from "./calendar_module";

import sbUser from "./sbUser";
import sbChannel from "./sbChannel";
import sbMessage from "./sbMessage";

import ogMeta from "./ogMeta";

import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const LOADER_TIMEOUT_MS = 10000;
let loaderWatchdog = null;
let dbgOpenedAt = 0; // [DBG]

export default new Vuex.Store({
  state: {
    isSignUpShouldnull: null,
    images: [],
    router: {
      to: null,
      from: null,
    },
    showFullContentLoader: false,
    blockScroll: false,
    isLoading: false,
    Loading: {
      text: "",
      cancel: false,
    },
    loaderLogs: [], // [DBG]
  },
  mutations: {
    setIsSignUpShouldnull(state, payload) {
      state.isSignUpShouldnull = payload;
    },
    setImages(state, payload) {
      state.images = payload;
    },
    setRouter(state, payload) {
      state.router = payload;
    },
    setShowFullContentLoader(state, payload) {
      state.showFullContentLoader = payload;
    },
    setBlockScroll(state, payload) {
      state.blockScroll = payload;
    },
    setIsLoading(state, payload) {
      if (typeof payload === "boolean") {
        state.isLoading = payload;
        state.Loading.text = "";
        state.Loading.cancel = false;
      } else {
        state.isLoading = payload.isLoading;
        state.Loading.text = payload.text || "";
        state.Loading.cancel = payload.cancel || false;
      }
    },
    // [DBG]
    pushLoaderLog(state, { kind, tag }) {
      if (kind === "show") dbgOpenedAt = performance.now();
      state.loaderLogs = [
        ...state.loaderLogs,
        {
          at: Math.round(performance.now() - dbgOpenedAt),
          kind,
          tag: tag || "?",
        },
      ].slice(-30);
    },
  },
  actions: {
    showFullContentLoader({ commit }, payload) {
      const isShow = typeof payload === "object" ? payload.show : payload;
      const tag = (typeof payload === "object" && payload.tag) || "?"; // [DBG]

      if (isShow) {
        if (loaderWatchdog) {
          commit("pushLoaderLog", { kind: "dup", tag }); // [DBG]
          return;
        }
        commit("pushLoaderLog", { kind: "show", tag }); // [DBG]
      } else {
        commit("pushLoaderLog", {
          kind: loaderWatchdog ? "hide" : "stray",
          tag,
        }); // [DBG]
      }

      clearTimeout(loaderWatchdog);
      loaderWatchdog = null;

      commit("setBlockScroll", isShow);
      commit("setShowFullContentLoader", isShow);

      if (isShow) {
        loaderWatchdog = setTimeout(() => {
          commit("pushLoaderLog", { kind: "warn", tag }); // [DBG]
          console.warn(`[watchdog] loader ${LOADER_TIMEOUT_MS / 1000}`);
          commit("setBlockScroll", false);
          commit("setShowFullContentLoader", false);
          loaderWatchdog = null;
        }, LOADER_TIMEOUT_MS);
      }
    },
  },
  modules: {
    user: UserModule,
    auth: AuthModule,
    maid: MaidModule,
    booking: BookingModule,
    calendar: CalendarModule,
    sbUser,
    sbChannel,
    sbMessage,
    ogMeta,
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      paths: ["auth", "user", "calendar", "booking", "maid"],
      key: "bluuu",
    }),
  ],
});